export const voicemail = {
  name: "voicemail" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M5.5 9.4a3.1 3.1 0 1 0 0 6.2 3.1 3.1 0 0 0 0-6.2Zm3.795 6.2A4.9 4.9 0 1 0 5.5 17.4h13a4.9 4.9 0 1 0-3.795-1.8h-5.41Zm9.205 0a3.1 3.1 0 1 0 0-6.2 3.1 3.1 0 0 0 0 6.2Z" clip-rule="evenodd"/></svg>`,
  keywords: ["voicemail"],
  category: "communication" as const,
};
